import { Link } from "react-router-dom";
import { Store } from "lucide-react";
import { useAuth } from "../stores/auth";
import { isMarketplaceLive } from "../lib/marketplace";
import { EmptyState, Button, PageLoader } from "./ui";
import { RequireModule } from "./RequireModule";

/** Marketplace module + `marketplace.enabled` setting (API returns 404 otherwise). */
export function RequireMarketplace({ children }: { children: React.ReactNode }) {
  const loading = useAuth((s) => s.loading);
  const config = useAuth((s) => s.config);
  const moduleEnabled = useAuth((s) => s.moduleEnabled);

  if (loading) return <PageLoader />;

  return (
    <RequireModule module="marketplace">
      {isMarketplaceLive(config, moduleEnabled) ? (
        children
      ) : (
        <div className="px-4 pt-4">
          <EmptyState
            icon={Store}
            title="Marketplace is not live yet"
            hint="Staff need to enable the Marketplace module and turn on Marketplace enabled in admin settings."
            action={
              <Link to="/">
                <Button variant="outline">Back to home</Button>
              </Link>
            }
          />
        </div>
      )}
    </RequireModule>
  );
}
